import { Button } from "@/components/ui/button";
import { ArrowRight, ArrowLeft, Mail, MapPin } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const CTASection = () => {
  const { t, isRTL } = useLanguage();

  return (
    <section className="py-20 lg:py-32 bg-background relative overflow-hidden" id="contact">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-purple rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 lg:gap-16">
            {/* Contact Info */}
            <div>
              <h2 className="text-4xl lg:text-5xl font-bold text-foreground mb-6 tracking-tight">
                {t("Contact us", "تواصل معنا")}
              </h2>
              <div className="space-y-6">
                <a
                  href="mailto:info@digitalbridgesa.com"
                  className="flex items-center gap-3 text-lg text-muted-foreground hover:text-primary transition-colors"
                >
                  <Mail className="w-6 h-6 text-primary" />
                  info@digitalbridgesa.com
                </a>
                <div className="flex items-start gap-3">
                  <MapPin className="w-6 h-6 text-primary shrink-0 mt-1" />
                  <div>
                    <p className="text-lg text-foreground font-medium">{t("Location", "الموقع")}</p>
                    <p className="text-muted-foreground">{t("Jeddah", "جدة")}</p>
                    <p className="text-muted-foreground">{t("Riyadh", "الرياض")}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Collaborate */}
            <div>
              <h2 className="text-4xl lg:text-5xl font-bold text-foreground mb-6 tracking-tight">
                {t("Collaborate", "تعاون معنا")}
              </h2>
              <p className="text-lg text-muted-foreground mb-8">
                {t(
                  "Ready to elevate your business and bridge the gap to success? Let's work together.",
                  "هل أنت مستعد للارتقاء بعملك وسد الفجوة نحو النجاح؟ لنعمل معاً."
                )}
              </p>
              <a href="/work-with-us">
                <Button size="lg" className="text-base font-semibold px-8">
                  {t("Get Started", "ابدأ الآن")}
                  {isRTL ? (
                    <ArrowLeft className="w-5 h-5 me-2" />
                  ) : (
                    <ArrowRight className="w-5 h-5 ms-2" />
                  )}
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
